"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPlatformAdminDeletedByListTenant = exports.userPlatformAdminDeletedByList = exports.userAdminPlatformValidatePasswordReset = exports.userAdminPlatformValidatePassword = exports.userAdminPlatformUpdate = exports.userAdminPlatformSoftDeletedList = exports.userAdminPlatformSoftDeleteRestore = exports.userAdminPlatformSoftDelete = exports.userAdminPlatformSearch = exports.userAdminPlatformResponseSuccess = exports.userAdminPlatformResponseError = exports.userAdminPlatformResetPassword = exports.userAdminPlatformReset = exports.userAdminPlatformList = exports.userAdminPlatformHardDelete = exports.userAdminPlatformDeactivate = exports.userAdminPlatformCreate = exports.userAdminPlatformActivate = void 0;
var _userAdminPlatform = require("./userAdminPlatform.constant");
// common success
var userAdminPlatformResponseSuccess = function userAdminPlatformResponseSuccess(actionType, data) {
  return {
    type: _userAdminPlatform.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.userAdminPlatformResponseSuccess = userAdminPlatformResponseSuccess;
var userAdminPlatformResponseError = function userAdminPlatformResponseError(actionType, error) {
  return {
    type: _userAdminPlatform.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Validate password
 * @param payload
 * @returns api response
 * @description this function used for validate Password of Platform Admin User.
 */
exports.userAdminPlatformResponseError = userAdminPlatformResponseError;
var userAdminPlatformValidatePassword = function userAdminPlatformValidatePassword(data) {
  return {
    type: _userAdminPlatform.actionTypes.VALIDATE_PASSWORD,
    payload: data
  };
};

/**
 * Validate password reset
 * @param payload
 * @returns api response
 * @description this function used for validate Password of Platform Admin User.
 */
exports.userAdminPlatformValidatePassword = userAdminPlatformValidatePassword;
var userAdminPlatformValidatePasswordReset = function userAdminPlatformValidatePasswordReset() {
  return {
    type: _userAdminPlatform.actionTypes.VALIDATE_PASSWORD_RESET
  };
};

/**
 * Search user
 * @param payload
 * @returns api response
 * @description this function used for search user of Platform User.
 */
exports.userAdminPlatformValidatePasswordReset = userAdminPlatformValidatePasswordReset;
var userAdminPlatformSearch = function userAdminPlatformSearch(data) {
  return {
    type: _userAdminPlatform.actionTypes.SEARCH,
    payload: data
  };
};

/**
 * Create platform admin user
 * @param payload
 * @returns api response
 * @description this function used for create platform admin user.
 */
exports.userAdminPlatformSearch = userAdminPlatformSearch;
var userAdminPlatformCreate = function userAdminPlatformCreate(data) {
  return {
    type: _userAdminPlatform.actionTypes.CREATE,
    payload: data
  };
};

/**
 * update platform admin user
 * @param payload
 * @returns api response
 * @description this function used for update platform admin user.
 */
exports.userAdminPlatformCreate = userAdminPlatformCreate;
var userAdminPlatformUpdate = function userAdminPlatformUpdate(data) {
  return {
    type: _userAdminPlatform.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Hard delete platform apdmin user
 * @param payload
 * @returns api response
 * @description this function used for hard delete platform admin user.
 */
exports.userAdminPlatformUpdate = userAdminPlatformUpdate;
var userAdminPlatformHardDelete = function userAdminPlatformHardDelete(data) {
  return {
    type: _userAdminPlatform.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * Platform admin user list
 * @param payload
 * @returns api response
 * @description this function used for hard delete platform admin user.
 */
exports.userAdminPlatformHardDelete = userAdminPlatformHardDelete;
var userAdminPlatformList = function userAdminPlatformList(data) {
  return {
    type: _userAdminPlatform.actionTypes.LIST,
    payload: data
  };
};

/**
 * Platform admin user reset password
 * @param payload
 * @returns api response
 * @description this function used for reset password of platform admin user.
 */
exports.userAdminPlatformList = userAdminPlatformList;
var userAdminPlatformResetPassword = function userAdminPlatformResetPassword(data) {
  return {
    type: _userAdminPlatform.actionTypes.RESET_PASSWORD,
    payload: data
  };
};

/**
 * Platform admin user activate
 * @param payload
 * @returns api response
 * @description this function used for activate of platform admin user.
 */
exports.userAdminPlatformResetPassword = userAdminPlatformResetPassword;
var userAdminPlatformActivate = function userAdminPlatformActivate(data) {
  return {
    type: _userAdminPlatform.actionTypes.ACTIVATE,
    payload: data
  };
};

/**
 * Platform admin user deactivate
 * @param payload
 * @returns api response
 * @description this function used for deactivate of platform admin user.
 */
exports.userAdminPlatformActivate = userAdminPlatformActivate;
var userAdminPlatformDeactivate = function userAdminPlatformDeactivate(data) {
  return {
    type: _userAdminPlatform.actionTypes.DEACTIVATE,
    payload: data
  };
};

/**
 * Reset user admin platform
 * @param payload
 * @returns api response
 * @description this function used to reset user admin platform.
 */
exports.userAdminPlatformDeactivate = userAdminPlatformDeactivate;
var userAdminPlatformReset = function userAdminPlatformReset() {
  return {
    type: _userAdminPlatform.actionTypes.RESET
  };
};

/**
 * Platform admin user soft delete
 * @param payload
 * @returns api response
 * @description this function used for soft delete of platform admin user.
 */
exports.userAdminPlatformReset = userAdminPlatformReset;
var userAdminPlatformSoftDelete = function userAdminPlatformSoftDelete(data) {
  return {
    type: _userAdminPlatform.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * Platform admin user soft delete restore
 * @param payload
 * @returns api response
 * @description this function used for restore of platform admin user.
 */
exports.userAdminPlatformSoftDelete = userAdminPlatformSoftDelete;
var userAdminPlatformSoftDeleteRestore = function userAdminPlatformSoftDeleteRestore(data) {
  return {
    type: _userAdminPlatform.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * Platform admin user soft delete list
 * @param payload
 * @returns api response
 * @description this function used for soft delete list of platform admin user.
 */
exports.userAdminPlatformSoftDeleteRestore = userAdminPlatformSoftDeleteRestore;
var userAdminPlatformSoftDeletedList = function userAdminPlatformSoftDeletedList(data) {
  return {
    type: _userAdminPlatform.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * list deleted by user
 * @param payload
 * @returns api response
 * @description this function used to get user's list for deleted by.
 */
exports.userAdminPlatformSoftDeletedList = userAdminPlatformSoftDeletedList;
var userPlatformAdminDeletedByList = function userPlatformAdminDeletedByList(data) {
  return {
    type: _userAdminPlatform.actionTypes.LIST_DELETED_BY_USER,
    payload: data
  };
};

/**
 * list deleted by user for tenant
 * @param payload
 * @returns api response
 * @description this function used to get tenants user's list for deleted by.
 */
exports.userPlatformAdminDeletedByList = userPlatformAdminDeletedByList;
var userPlatformAdminDeletedByListTenant = function userPlatformAdminDeletedByListTenant(data) {
  return {
    type: _userAdminPlatform.actionTypes.LIST_DELETED_BY_USER_TENANT,
    payload: data
  };
};
exports.userPlatformAdminDeletedByListTenant = userPlatformAdminDeletedByListTenant;